import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API, apiError, SITE } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem("eclipsia_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-black flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="glass-strong rounded-[1.5rem] p-8 w-full max-w-sm flex flex-col gap-5">
        <img src={SITE.logo} alt="Eclipsia" className="h-14 w-auto self-center" />
        <p className="text-center text-xs tracking-[0.3em] uppercase text-white/60 font-body font-medium">Area Riservata</p>
        <input data-testid="admin-email-input" className="glass-input" type="text" autoCapitalize="none" autoComplete="username" required placeholder="Email o nome utente" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="admin-password-input" className="glass-input" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        {error && <p data-testid="admin-login-error" className="text-xs text-red-300 font-body">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit"
          className="bg-white text-black rounded-full px-6 py-3.5 text-sm font-medium font-body flex items-center justify-center gap-2 hover:opacity-90 transition-opacity disabled:opacity-60">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Accedi"}
        </button>
      </form>
    </main>
  );
}
